import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EventsService} from './event.service';
import {TableSearcherComponent} from './table-searcher.component';
import {TableSearcherService} from './table-searcher.service';
import {HttpClientModule} from '@angular/common/http';
export class AngularTableSearcherModule {
/**
 * @return {?}
 */
static forRoot() {
    return {
      ngModule: AngularTableSearcherModule,
      providers: [TableSearcherService, EventsService]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpClientModule,
    CommonModule
  ],
  declarations: [TableSearcherComponent],
  exports: [TableSearcherComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AngularTableSearcherModule_tsickle_Closure_declarations() {
/** @type {?} */
AngularTableSearcherModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularTableSearcherModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
